import { fontFamily } from "./index206.js";
import { indexToLetter } from "./index207.js";
import { Html } from "@react-three/drei";
import { jsxs } from "react/jsx-runtime";
const BuildingName = ({ building }) => {
	return /* @__PURE__ */ jsxs(Html, {
		center: true,
		style: {
			pointerEvents: "none",
			padding: "2px 8px",
			borderRadius: "4px",
			background: "#0D0E0F",
			color: "#fff",
			fontFamily,
			fontSize: 14
		},
		children: ["Block\xA0", indexToLetter(building.data.index)]
	});
};
export { BuildingName };

//# sourceMappingURL=index208.js.map